import { render, staticRenderFns } from "./MarkStudentAsMatchedModal.vue?vue&type=template&id=319b1be4&"
import script from "./MarkStudentAsMatchedModal.vue?vue&type=script&lang=ts&"
export * from "./MarkStudentAsMatchedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports